import React from "react";
import { Select, Typography } from "antd";
import { useSelector } from "react-redux";

const { Text } = Typography;

const SymbolSelector = ({ selectedSymbol, onSymbolChange, disabled }) => {
  const symbolsGroupedInSectored = useSelector(
    (state) => state.main.symbolsGroupedInSectored,
  );
  // const symbolsGroupedInSectored = [
  //   {
  //     label: "Multi sector",
  //     options: [
  //       {
  //         label: "Direxion Daily Semiconductor Bull 3X ETF",
  //         value: "SOXL",
  //       },
  //     ],
  //   },
  // ];

  return (
    <div>
      <Text strong>Select Stock:</Text>
      <Select
        placeholder="Enter symbol name"
        showSearch
        dropdownMatchSelectWidth={252}
        options={symbolsGroupedInSectored}
        filterOption={(inputValue, option) =>
          option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        style={{ width: "100%", marginTop: 8 }}
        allowClear
        onSelect={(value) => onSymbolChange(value)}
        onClear={() => onSymbolChange(null)}
        value={selectedSymbol}
        disabled={disabled}
      />
    </div>
  );
};

export default SymbolSelector;
